module.exports = __webpack_public_path__ + "static/Abe_Clark_thumbnail_headshot.b1f35f31.jpeg";


//////////////////
// WEBPACK FOOTER
// ./media/Abe_Clark_thumbnail_headshot.jpeg
// module id = 589
// module chunks = 0